"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      style={{
        background: "var(--color-bg-dark)",
        padding: "100px 24px",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle gradient accent */}
      <div
        style={{
          position: "absolute",
          top: "-30%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)",
              color: "#fff",
              marginBottom: 20,
              lineHeight: 1.15,
              maxWidth: 700,
              margin: "0 auto 20px",
            }}
          >
            Ready to give your research team or call center more reach with{" "}
            <em style={{ fontFamily: "var(--font-heading)" }}>less manual effort?</em>
          </h2>
          <p
            style={{
              fontSize: "clamp(0.95rem, 1.2vw, 1.08rem)",
              color: "rgba(255,255,255,0.65)",
              fontWeight: 300,
              lineHeight: 1.75,
              maxWidth: 600,
              margin: "0 auto 40px",
            }}
          >
            Choose the plan that fits your volume, launch through Stripe, and start
            building a more efficient voice operation with Ethos Virtual.
            Custom setup included. Live today.
          </p>
          <div
            style={{
              display: "flex",
              gap: 14,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <a
              href="#pricing"
              className="btn-primary"
              style={{
                background: "#fff",
                color: "var(--color-text)",
                padding: "16px 36px",
              }}
            >
              Choose Your Plan
              <ArrowRight size={16} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
